"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logEvent = logEvent;
exports.logImpression = logImpression;
// TODO: cleanup post swp-siteglass https://jira.godaddy.com/browse/NXT-1930

function logImpression(eid) {
  if (typeof window === 'undefined') return;
  window._expDataLayer = window._expDataLayer || [];
  window._expDataLayer.push({
    schema: 'add_impression',
    version: 'v1',
    data: {
      eid
    }
  });
}
function logEvent({
  eid,
  type,
  properties
}) {
  if (typeof window === 'undefined') return;
  window._expDataLayer = window._expDataLayer || [];
  window._expDataLayer.push({
    schema: 'add_event',
    version: 'v1',
    data: {
      eid,
      type,
      properties
    }
  });
}